import { ZIndexOptions } from '@mui/material/styles/zIndex';

export const zIndex: ZIndexOptions = {
  drawer: 1300,
  sidebar: 1,
};
